module.exports = __webpack_public_path__ + "img/WINGS.c32f646c.svg";